const messages = {
  de: {
    legal: {
      cookieNotice:
        'Diese Website verwendet Cookies – nähere Informationen dazu finden Sie in unserer Datenschutzerklärung am Ende der Seite.',
      acceptCookies: 'Cookies akzeptieren und schließen',
      declineCookies: 'essentielle Cookies akzeptieren',
    },
    forms: {
      businessCustomerCheck: 'Ich buche diese Tour für ein Unternehmen.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Firma',
      city: 'Ort',
      zip: 'PLZ',
      zipTitle: 'Für Buchungen aus dem Ausland bitte die 99999 eingeben!',
      street: 'Straße, Nr.',
      message: 'Nachricht',
      agb: 'Ich akzeptiere die <a href="{link}" target="_blank">AGB</a>.',
      dsgvoMessage:
        'Ich stimme zu, dass zur Beantwortung meiner Anfrage meine Angaben aus dem Kontaktformular erhoben und verarbeitet werden dürfen. Hinweise: Nach abgeschlossener Bearbeitung der Anfrage werden die Daten gelöscht. Die Einwilligung kann jederzeit für die Zukunft per E-Mail an info@citygames.de widerrufen werden. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer <a href="{link}" target="_blank">Datenschutzerklärung</a> *',
      peopleCount: 'Gruppengröße',
      playDate: 'Wunschdatum',
      playTime: 'Wunschuhrzeit',
      next: 'weiter',
      send: 'Senden',
      sendRequest: 'Angebot anfragen',
      bookNow: 'Jetzt buchen',
      requiredFields: 'Bitte fülle folgende Pflichtfelder aus:',
      persons: 'Personen',
      clock: 'Uhr',
    },
    configurator: {
      heading: {
        configurator: 'Tourenkonfigurator',
        booking: 'Buchung',
        inquiry: 'Anfrage',
      },
      chooseTour: 'Tour wählen',
      chooseTourLong: 'Bitte wähle deine Wunschtour 😎',
      price: 'Bereits ab {price}',
      extras: 'Extras',
      chooseExtra: 'Wähle deine Extras für die {tourName} 👇',
      chooseModalities: 'Wann und mit wie vielen Personen möchtest du die {tourName} starten?',
      chooseSpecials: 'Wähle deine Specials:',
      nextWithoutSpecials: '>> weiter ohne Specials',
      specials: 'Specials',
      checkoutEmojis: '🎉 🥳',
      checkoutMessage: '👊 Fast geschafft. Nur noch...',
      perPerson: 'pro Person',
      perPersonShort: 'p.P.',
      flatRate: 'pauschal',
      chooseSpecial: 'Special wählen',
      summary: 'Zusammenfassung',
      thankYou: 'Herzlichen Dank für Deine Tourenkonfiguration',
      thankYouText:
        'Wir werden Dein Anliegen schnellstmöglich bearbeiten und uns anschließend bei Dir melden. \n Vielen Dank und bis bald! Dein Biertour-Team',
      groupSize: 'Gruppengröße',
      dateAndTime: 'Datum & Uhrzeit',
      pricePerPerson: 'Preis pro Person:',
      total: 'Gesamtpreis:',
      request: 'Ich möchte lieber erst einmal eine unverbindliche Anfrage senden.',
    },
  },
};

export { messages as default };
